export default "__VITE_ASSET__BFXzhXTr__"